export default __webpack_public_path__ + "static/media/vk.3b8b742e.png";